import {AppLinkDto, mapiqApi} from '@lib/infrastructure';
import {AppThunkApiConfig} from '../../createStore';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {FeatureToggle} from '../entities';

export const getAppLink = createAsyncThunk<AppLinkDto, string, AppThunkApiConfig>(
  'appLinks/load',
  async (appLinkId, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);
    const response = await api.getAppLink(appLinkId);

    return response;
  },
  {
    condition: (_arg, {getState}) => getState().data.features.enabledFeatures.includes(FeatureToggle.AppLinks),
  },
);
